/** @file Image direction from the pivot toward the anchor end of a drawn bone (design 15.4, 15.5). */
import { imageDirOf } from '@zilo/pose3d-render-core/cut/imageDirOf';

/** `imageDirOf(r + 180) = [-sin r, -cos r]`: the drawn bone runs anchor -> pivot along `r`. */
export function anchorDirOf(drawnScreenAngleDeg: number): [number, number] {
  return imageDirOf(drawnScreenAngleDeg + 180);
}
